/** Route policy for the mobile app shell (pure, unit-tested). */

const HIDDEN_PREFIXES = [
  '/admin',
  '/ofuesi-2026-regional-conference/',
  '/hotel-accommodation-guide',
  '/documents/',
];

/** The shell is for the public app only — never over admin or document views. */
export const shouldShowMobileShell = (pathname: string): boolean => {
  const path = pathname || '/';
  return !HIDDEN_PREFIXES.some((prefix) => path === prefix || path.startsWith(prefix));
};

export type MobileTabId = 'home' | 'conferences' | 'prayer' | 'resources' | 'more';

export const MOBILE_TABS: { id: MobileTabId; label: string; to?: string; match?: string[] }[] = [
  { id: 'home', label: 'Home', to: '/', match: ['/'] },
  {
    id: 'conferences',
    label: 'Conferences',
    to: '/conference',
    match: ['/conference', '/conferences', '/registrations'],
  },
  { id: 'prayer', label: 'Prayer', to: '/prayer', match: ['/prayer'] },
  { id: 'resources', label: 'Resources', to: '/keep-in-touch', match: ['/keep-in-touch', '/gallery'] },
  { id: 'more', label: 'More' },
];

/** Which tab should render as active for a given path. */
export const getActiveTab = (pathname: string): MobileTabId | null => {
  const path = (pathname || '/').replace(/\/+$/, '') || '/';
  if (path === '/') return 'home';
  for (const tab of MOBILE_TABS) {
    if (!tab.match) continue;
    if (tab.match.some((prefix) => prefix !== '/' && (path === prefix || path.startsWith(`${prefix}/`)))) {
      return tab.id;
    }
  }
  return null;
};
